
import {Component, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";

@Component
export default class UyapConnectionInfo extends Vue {
  @Getter isUyapConnected!: boolean;
  @Getter isDevMode!: boolean;
  @Action connectToUyap!: () => void;
  @Getter isTokenExis!: boolean;

  get iconColor(): string {
    return this.isUyapConnected ? 'green' : 'white';
  }

  get tooltipText(): string {
    return this.isUyapConnected ? 'UYAP Bağlantısını yenile.' : "Uyap'a Bağlan";
  }

  handleAction(): void {
    if (this.isUyapConnected) {
      this.openUyap();
    } else {
      this.connectToUyap();
    }
  }

  openUyap(): void {
    this.$store.dispatch('openUyapWindow');
  }
}
